import React, { useEffect, useState } from "react";
import css from "./Benefits.module.css";

interface BenefitItem {
  title: string;
  text: string;
  icon: string;
}

interface BenefitsProps {
  sectionTitle: string;
  items: BenefitItem[];
}

const Benefits: React.FC<BenefitsProps> = ({ sectionTitle, items }) => {
  const [icons, setIcons] = useState<string[]>([]);

  // Log the props received by the component
  useEffect(() => {
    console.log("Benefits component received:", {
      sectionTitle,
      items: items.map((item) => ({
        title: item.title,
        textLength: item.text ? item.text.length : 0,
        textPreview: item.text ? item.text.substring(0, 100) : "null",
        icon: item.icon,
      })),
    });
  }, [sectionTitle, items]);

  useEffect(() => {
    const fetchIcons = async () => {
      try {
        const fetchedIcons = await Promise.all(
          items.map((item) => fetch(`${item.icon}`).then((res) => res.text()))
        );
        setIcons(fetchedIcons);
        console.log("Fetched icons:", fetchedIcons);
      } catch (error) {
        console.error("Error fetching benefit icons:", error);
      }
    };

    fetchIcons();
  }, [items]);

  return (
    <section className={css.fullWidthBackground}>
      <div className={css.container}>
        <div className={css.benefitsContainer}>
          <header className={css.header}>
            <h2 className={css.title}>{sectionTitle}</h2>
          </header>

          <div className={css.grid}>
            {items.map((item, index) => {
              console.log(`Rendering benefit ${index}:`, {
                title: item.title,
                textPreview: item.text?.substring(0, 50) || "null",
                hasIcon: Boolean(icons[index]),
              });

              return (
                <article key={index} className={css.card}>
                  {icons[index] && (
                    <div
                      className={css.icon}
                      dangerouslySetInnerHTML={{ __html: icons[index] }}
                    />
                  )}
                  <h3 className={css.cardTitle}>{item.title}</h3>
                  <div
                    className={css.cardText}
                    dangerouslySetInnerHTML={{ __html: item.text }}
                  />
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
